import React, {useEffect, useState} from 'react';
import { renderDropdown, renderDropdownReadOnly} from "../../gdpr/ui/DropdownFunctions";
import SpinnerDiv from "../../gdpr/ui/SpinnerDiv";
import PropTypes from "prop-types";
import {getAccessHoursData} from "../../gdpr/ui/DropdownDataProviders";

const DropdownAccessHours = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getAccessHoursData().then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })
    }, []);

    const options = {
        isSearchable: true,
        isClearable: props.isClearable === null || props.isClearable === undefined ? true : props.isClearable,
    }

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data, options)
    )
}

export default DropdownAccessHours;

DropdownAccessHours.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownAccessHours.propTypes = {
    onChange: PropTypes.func.isRequired
};